import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent, useState, type RefObject } from "react";
import { useScrollPositionContext } from "@/contexts/ScrollPositionContext";
export function usePersistentScrollOffset(scrollKey, scrollContainerRef) {
  const $ = _c(13);
  const {
    getPosition,
    setPosition
  } = useScrollPositionContext();
  let t0;
  if ($[0] !== getPosition || $[1] !== scrollKey) {
    t0 = () => getPosition(scrollKey);
    $[0] = getPosition;
    $[1] = scrollKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [initialOffset] = useState(t0);
  let t1;
  if ($[3] !== scrollContainerRef || $[4] !== scrollKey || $[5] !== setPosition) {
    t1 = () => {
      const container = scrollContainerRef.current;
      if (!container) {
        return;
      }
      setPosition(scrollKey, container.scrollTop);
    };
    $[3] = scrollContainerRef;
    $[4] = scrollKey;
    $[5] = setPosition;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const persistScrollPosition = useEffectEvent(t1);
  let t2;
  if ($[7] !== persistScrollPosition || $[8] !== scrollContainerRef) {
    t2 = () => {
      const container_0 = scrollContainerRef.current;
      if (!container_0) {
        return;
      }
      const handleScroll = () => {
        persistScrollPosition();
      };
      container_0.addEventListener("scroll", handleScroll);
      return () => {
        persistScrollPosition();
        container_0.removeEventListener("scroll", handleScroll);
      };
    };
    $[7] = persistScrollPosition;
    $[8] = scrollContainerRef;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== persistScrollPosition || $[11] !== scrollKey) {
    t3 = [persistScrollPosition, scrollKey];
    $[10] = persistScrollPosition;
    $[11] = scrollKey;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useEffect(t2, t3);
  return initialOffset;
}